module.exports = __webpack_public_path__ + "img/pompiers.49baf6a5.jpg";